import $ from 'jquery';
import ajax from '../services/ajax';
import config from '../config/index.js';
import cookieUtil from 'js-cookie';
import _get from 'lodash.get';

const siteUrl = 'https://' + config.get('currentSiteUrl');

class SocialAuth {
    constructor() {
        this.scopedClickListener = this.clickListener.bind(this);
        this.scopedTwitterAuthSuccess = this.twitterAuthSuccess.bind(this);
        this.getUserUrl = '__/api/v1/hi';
    }

    clickListener() {
        this.popupWindow = window.open(
            `//www.fastyou.com/__/auth/twitter?onsuccess=${siteUrl}/__/auth/success&onfail=${siteUrl}/__/auth/error`,
            'FastCompanyAuthWindow',
            'width=990,height=580,left=30,top=538.5,resizable'
        );
        $(window).on('fc_auth_social_success', this.scopedTwitterAuthSuccess);
    }

    twitterAuthSuccess() {
        $(window).off('fc_auth_social_success', this.scopedTwitterAuthSuccess);
        this.showFbSuccess();
        this.getUser().then(() => {
            this.showUserSuccess();
        }).catch(() => {
            this.showUserFailure();
        });
    }

    getUser() {
        const authCookie = cookieUtil('fc_auth');
        if (authCookie) {
            const url = `${siteUrl}/${this.getUserUrl}`;
            return ajax(url, {
                dataType: 'jsonp'
            }).then((userData) => {
                this.userData = _get(userData, 'user');
            });
        }
        throw new Error('fc_auth cookie not available.');
    }

    showFbSuccess() {
        this.$socialSuccess.html(`
            <h1>Successfully Connected to twitter.</h1>
        `);
    }

    showUserSuccess() {
        const provider = this.userData.p;
        const username = this.userData.n;
        const uuid = this.userData.u;
        this.$socialSuccess.html(`
            <h1>Sign Up Success. You now have an account.</h1>
            <h1>Log In Success. You are now logged in.</h1>
            <h1>This is your user information:</h1>
            <h1>Authentication Method: ${provider}</h1>
            <h1>User Name: ${username}</h1>
            <h1>Unique Identifier: ${uuid}</h1>
        `);
    }

    showUserFailure() {
        this.$socialSuccess.html(`
            <h1>Error signing up. Please try another method.</h1>
        `);
    }

    on() {
        this.$socialSuccess = $('.js-social-success');
        this.$twitterBtn = $('.js-twitter-login');
        this.$twitterBtn.on('click', this.scopedClickListener);
    }

    off() {
        this.$twitterBtn.off('click', this.scopedClickListener);
        $(window).off('fc_auth_fb_success', this.scopedTwitterAuthSuccess);
        this.popupWindow = undefined;
    }
}

export default new SocialAuth();


